import { parse, format, resolve } from 'url';
var url = {
  parse: parse,
  format: format,
  resolve: resolve
};
export { url };